type TextProps = {
  textLabel: string
  fontWeight: string
  fontSize: string
  customClass?: string
  fontColor?: string
  role?: string
}

export const CustomText: React.FC<TextProps> = ({
  textLabel,
  fontWeight,
  fontSize,
  fontColor,
  customClass,
  role
}) => {
  return (
    <p
      role={role}
      className={`font-roboto font-poppins ${
        fontColor ? fontColor : 'text-black'
      }  ${fontWeight} ${fontSize} ${customClass}`}
    >
      {textLabel}
    </p>
  )
}

export default CustomText
